<template>
  <div
    style="width: 60px; height: 60px"
    :style="{ transform: 'rotate(' + turn + 'deg)' }"
  >
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.1822 9.10456C28.2649 11.1877 31.6418 11.1877 33.7244 9.10456C35.8071 7.02189 35.8071 3.645 33.7244 1.56233C31.6418 -0.520778 28.2649 -0.520778 26.1822 1.56233C24.0991 3.645 24.0991 7.02189 26.1822 9.10456ZM12.5289 17.9157C15.4742 17.9157 17.8622 15.5272 17.8622 12.5823C17.8622 9.63656 15.4742 7.249 12.5289 7.249C9.5831 7.249 7.19554 9.63656 7.19554 12.5823C7.19554 15.5272 9.5831 17.9157 12.5289 17.9157ZM47.4 17.8623C44.4533 17.8623 42.0667 15.4743 42.0667 12.529C42.0667 9.58322 44.4533 7.19567 47.4 7.19567C50.3449 7.19567 52.7333 9.58322 52.7333 12.529C52.7333 15.4743 50.3449 17.8623 47.4 17.8623ZM50.8764 26.1823C48.7938 28.265 48.7938 31.6419 50.8764 33.7246C52.9595 35.8072 56.3364 35.8072 58.4187 33.7246C60.5018 31.6419 60.5018 28.265 58.4187 26.1823C56.3364 24.0992 52.9595 24.0992 50.8764 26.1823ZM26.2569 50.8766C28.3395 48.7939 31.7164 48.7939 33.7991 50.8766C35.8822 52.9597 35.8822 56.3366 33.7991 58.4188C31.7164 60.5019 28.3395 60.5019 26.2569 58.4188C24.1742 56.3366 24.1742 52.9597 26.2569 50.8766ZM17.9147 47.4526C17.9147 44.5072 15.5271 42.1192 12.5813 42.1192C9.63643 42.1192 7.24799 44.5072 7.24799 47.4526C7.24799 50.3979 9.63643 52.7859 12.5813 52.7859C15.5271 52.7859 17.9147 50.3979 17.9147 47.4526ZM9.10443 26.257C11.1875 28.3397 11.1875 31.7166 9.10443 33.7992C7.02177 35.8823 3.64488 35.8823 1.56221 33.7992C-0.5209 31.7166 -0.5209 28.3397 1.56221 26.257C3.64488 24.1743 7.02177 24.1743 9.10443 26.257Z"
        fill="var(--gray400)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.4525 42.0664C44.5071 42.0664 42.1191 44.4531 42.1191 47.3997C42.1191 50.3446 44.5071 52.7331 47.4525 52.7331C50.3978 52.7331 52.7858 50.3446 52.7858 47.3997C52.7858 44.4531 50.3978 42.0664 47.4525 42.0664Z"
        fill="var(--brandPrimary)"
      />
    </svg>
  </div>
</template>

<script>
let turn = 40;
export default {
  name: "SpinnerCircle",
  data() {
    return {
      turn: turn,
      intervalId: null,
    };
  },
  mounted() {
    this.intervalId = setInterval(this.rotateSpinner, 75);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    rotateSpinner() {
      this.turn += 45;
      this.turn %= 360;
    },
  },
};
</script>

<style scoped></style>
